import React, { useState, useEffect, useRef } from "react";
import { getData } from "app/data";
import MerchantService from "components/MerchantService";
import PageHeader from "components/PageHeader/TitleSubtitlePageHeader/MerchantService";
import CommonUseCases from "components/CommonUseCases"
import WaitingFor from "components/Banner/WaitingFor";
import ProductCard from "./ProductCard";
import "./ServiceRate.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import Faq from "../Faq";
import { useSmoothScroll } from './useSmoothScroll';
import ServiceRateContent from "./ServiceRateContent";
import { FormattedMessage } from "react-intl";

export default function Index() {
  const { myRef, clickHandle } = useSmoothScroll();

  const data = getData("serviceRatesData");
  // const contentData = getData("serviceRatePageData")
  const faqData = getData("serviceRatePageFaqData");
  const [activeBtn, setActiveBtn] = useState("merchant-service");
  useEffect(() => {
    let urlArr = window.location.pathname.split("/");
    setActiveBtn(urlArr[1])
  }, []);

  return (
    <div className="merchant-service-page">
      <PageHeader
        title="merchant_service"
        subtitle="browse_pos_devices"
        subtitle2="browse_by_use_cases"
        subtitle3="service_rate"
        subtitleColorGreen={true}
        activeBtn={activeBtn}
        clickHandle={clickHandle}
        // modified code
        introduction="merchant_service_introduction"
      />
      <hr ref={myRef} />


      <MerchantService data={getData("serviceRateData")} />
      <div className="serviceRate" >
        <div className="container div-wrapper">
          <div class="personalized-pricing">
            {/* modified codes */}
            <h1><FormattedMessage id={"personalized_pricing"}/></h1>
            <p><FormattedMessage id={"rates_continue"}/></p>
            <p><FormattedMessage id={"no_phone"}/></p>
          </div>
          <div className="row">
            {data.map((item) => (
              <ProductCard
                key={item.title}
                link={item.link}
                title={item.title}
                subtitle={item.text}
                showImage={false}
                showHover={false}
                hashTag={item.hash}
              />
            ))}
          </div>
        </div>
      </div>
      {/* <section className="serviceRateContent" >
        <div className="container">
          {contentData.map((item, idx) => {
            return (
              <div className="row" key={idx}>
                <div className="text-wrapper">
                  <div className="title">
                    <h2>{item.title}</h2>
                  </div>
                  <div className="text">
                    {item.text && Array.isArray(item.text) ?
                      item.text.map((textItem, index) => (
                        <div key={index}>
                          <p>
                            {idx === 2 ? <FontAwesomeIcon icon={faCheckCircle} /> : idx === 0 ?
                              <FontAwesomeIcon icon={faDollarSign} /> : null
                            }
                            {textItem}</p>

                        </div>
                      )) :
                      <span>{item.text}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section> */}
      <ServiceRateContent name="serviceRatePageData" />




      <Faq fromServiceRate={true} faqpost_en={faqData} faqpost_zh={faqData} />
    </div >
  );
}
